module.exports = "https://www.svtstatic.se/play/play7/_next/static/images/play_default_650x365-b2e1818f1d1af3e986e869822328e961.jpg";